import { render } from "./raceAdd.vue?vue&type=template&id=1707ebd9&scoped=true"
import script from "./raceAdd.vue?vue&type=script&lang=js"
export * from "./raceAdd.vue?vue&type=script&lang=js"

import "./raceAdd.vue?vue&type=style&index=0&id=1707ebd9&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1707ebd9"]])

export default __exports__